var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2963_37009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 31C24.732 31 31 24.732 31 17C31 9.268 24.732 3 17 3C9.268 3 3 9.268 3 17C3 24.732 9.268 31 17 31Z",
    fill: "#196DFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 31C24.732 31 31 24.732 31 17C31 9.268 24.732 3 17 3C9.268 3 3 9.268 3 17C3 24.732 9.268 31 17 31Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 29C10.373 29 5 23.627 5 17C5 10.373 10.373 5 17 5C23.627 5 29 10.373 29 17C29 23.627 23.627 29 17 29Z",
    fill: "#196DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 29C10.373 29 5 23.627 5 17C5 10.373 10.373 5 17 5C23.627 5 29 10.373 29 17C29 23.627 23.627 29 17 29Z",
    fill: "#196DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 13H21.2C21.48 13 21.62 13 21.727 13.054C21.821 13.1022 21.8973 13.1788 21.945 13.273C22 13.38 22 13.52 22 13.8V21.511C22 21.803 22 21.949 21.913 22.144C21.8268 22.3097 21.7049 22.4542 21.556 22.567C21.379 22.685 21.268 22.704 21.045 22.742C20.3 22.87 19.04 23 17 23C14.96 23 13.7 22.87 12.955 22.742C12.732 22.704 12.621 22.685 12.444 22.567C12.2951 22.4542 12.1732 22.3097 12.087 22.144C12 21.949 12 21.803 12 21.51V13.8C12 13.52 12 13.38 12.054 13.273C12.102 13.1787 12.1787 13.102 12.273 13.054C12.38 13 12.52 13 12.8 13H14.5V12.5C14.5 11.837 14.7634 11.2011 15.2322 10.7322C15.7011 10.2634 16.337 10 17 10C17.663 10 18.2989 10.2634 18.7678 10.7322C19.2366 11.2011 19.5 11.837 19.5 12.5V13ZM15.7 13V12.5C15.7 12.1552 15.837 11.8246 16.0808 11.5808C16.3246 11.337 16.6552 11.2 17 11.2C17.3448 11.2 17.6754 11.337 17.9192 11.5808C18.163 11.8246 18.3 12.1552 18.3 12.5V13H15.7ZM17 18.5C16.337 18.5 15.7011 18.2366 15.2322 17.7678C14.7634 17.2989 14.5 16.663 14.5 16V15H15.5V16C15.5 16.197 15.5388 16.392 15.6142 16.574C15.6896 16.756 15.8001 16.9214 15.9393 17.0607C16.0786 17.1999 16.244 17.3104 16.426 17.3858C16.608 17.4612 16.803 17.5 17 17.5C17.197 17.5 17.392 17.4612 17.574 17.3858C17.756 17.3104 17.9214 17.1999 18.0607 17.0607C18.1999 16.9214 18.3104 16.756 18.3858 16.574C18.4612 16.392 18.5 16.197 18.5 16V15H19.5V16C19.5 16.663 19.2366 17.2989 18.7678 17.7678C18.2989 18.2366 17.663 18.5 17 18.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2963_37009",
    x: 1,
    y: 2,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2963_37009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2963_37009",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopMark);
export default __webpack_public_path__ + "static/media/shopMark.2b9980a9ef027120aff333afe287f915.svg";
export { ForwardRef as ReactComponent };